export const setUserRole = (role) => ({
    type: 'SET_USER_ROLE',
    payload: role,
  });
export const setUserName = (username) => ({
    type: 'SET_USER_NAME',
    payload: username,
  });
  
  